export const REQUEST_AWARDS_DATA = 'REQUEST_AWARDS_DATA';
export const RECEIVE_AWARDS_DATA = 'RECEIVE_AWARDS_DATA';

export const receiveAwardsData = (payload) => ({
  type: RECEIVE_AWARDS_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/awardsActions.js